import {
  faLinkedin,
  faTelegramPlane,
  faTwitter,
  faWhatsapp
} from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TooltipMF from 'components/shared/TooltipMF';
import { useI18n } from 'hooks/useI18n';
import { useRef, useState } from 'react';
import ReactModal from 'react-modal';
import ButtonLink from '../../shared/ButtonLink.styled';
import FormGroup from '../../shared/FormGroup';
import InputText from '../../shared/InputText';
import Modal from '../../shared/Modal';
import {
  StyledCopyAnchor,
  StyledCopyWrapper,
  StyledShareModalButtons
} from './ShareModal.styled';
import { ShareModalProps } from './ShareModal.types';

export const ShareModal: React.FC<ShareModalProps> = ({
  twitterMessage,
  telegramMessage,
  whatsappMessage,
  emailMessage,
  emailSubject,
  isOpened,
  close,
  url
}) => {
  const { t } = useI18n('common');
  const linkInputRef = useRef<HTMLInputElement>(null);
  const [copied, setCopied] = useState(false);

  return (
    <ReactModal
      isOpen={isOpened}
      contentLabel={t('share-modal.shareAction')}
      onAfterOpen={() => {
        setCopied(false);
      }}
      shouldCloseOnOverlayClick={true}
      onRequestClose={close}
    >
      <Modal title={t('share-modal.share')} onClose={close}>
        <div>
          <StyledShareModalButtons>
            <ButtonLink
              variant="secondary"
              sizes="md"
              isIcon={true}
              href={`http://twitter.com/share?text=${twitterMessage}&url=${encodeURIComponent(
                url
              )}`}
              target="_blank"
              rel="noreferrer"
              title={t('share-modal.twitter')}
            >
              <FontAwesomeIcon aria-hidden="true" icon={faTwitter} />
            </ButtonLink>
            <ButtonLink
              variant="secondary"
              sizes="md"
              isIcon={true}
              href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
                url
              )}`}
              target="_blank"
              rel="noreferrer"
              title={t('share-modal.linkedin')}
            >
              <FontAwesomeIcon aria-hidden="true" icon={faLinkedin} />
            </ButtonLink>
            <ButtonLink
              variant="secondary"
              sizes="md"
              isIcon={true}
              href={`https://telegram.me/share/url?url=${encodeURIComponent(
                url
              )}&text=${telegramMessage}`}
              target="_blank"
              rel="noreferrer"
              title={t('share-modal.telegram')}
            >
              <FontAwesomeIcon aria-hidden="true" icon={faTelegramPlane} />
            </ButtonLink>
            <ButtonLink
              variant="secondary"
              sizes="md"
              isIcon={true}
              href={`https://api.whatsapp.com/send?text=${whatsappMessage} ${encodeURIComponent(
                url
              )}`}
              target="_blank"
              rel="noreferrer"
              title={t('share-modal.whatsapp')}
            >
              <FontAwesomeIcon aria-hidden="true" icon={faWhatsapp} />
            </ButtonLink>
            <ButtonLink
              variant="secondary"
              sizes="md"
              isIcon={true}
              href={`mailto:?subject=${encodeURIComponent(
                emailSubject
              )}&body=${emailMessage} ${encodeURIComponent(url)}`}
              target="_blank"
              rel="noreferrer"
              title={t('share-modal.email')}
            >
              <FontAwesomeIcon aria-hidden="true" icon={faEnvelope} />
            </ButtonLink>
          </StyledShareModalButtons>
          <FormGroup label={`${t('share-modal.copyLink')}`} forId="shareLink">
            <InputText
              id="shareLink"
              type="text"
              value={url}
              title={url}
              variant="copy"
              readOnly
              ref={linkInputRef}
              onClick={() => {
                linkInputRef.current?.select();
                document.execCommand('copy');
                setCopied(true);
                setTimeout(() => {
                  setCopied(false);
                }, 2000);
              }}
            />
            <StyledCopyWrapper>
              <TooltipMF
                content={t('share-modal.linkCopy')}
                direction="up"
                distance={65}
                isOpen={copied}
              >
                <StyledCopyAnchor />
              </TooltipMF>
            </StyledCopyWrapper>
          </FormGroup>
        </div>
      </Modal>
    </ReactModal>
  );
};
